import React, { Component } from 'react'
import { getReferences, getStudyPeriodWeightings } from '../../services/vu'
import {
  getSemester1BlockModelCalendarTypes,
  getSemester2BlockModelCalendarTypes,
  getVuOnlineStudyPeriodCalendarTypes,
  getSummerBlockModelCalendarTypes,
  getSupportedCalendarTypes,
  getWinterBlockModelCalendarTypes,
  getSummerBlockModelOpeningCalendarTypes,
  getSummerBlockModelClosingCalendarTypes,
  getSemester1DualInstanceBlockModelCalendarTypes,
  getSemester2DualInstanceBlockModelCalendarTypes,
  getDualInstanceBlockWeek5CalendarTypes,
  HIGHER_EDUCATION_SEMESTER_1,
  HIGHER_EDUCATION_SEMESTER_2,
  HIGHER_EDUCATION_SEMESTER_3,
  HIGHER_EDUCATION_SEMESTER_4,
  HIGHER_EDUCATION_MELBOURNE_TRIMESTER_1,
  HIGHER_EDUCATION_MELBOURNE_TRIMESTER_2,
  HIGHER_EDUCATION_MELBOURNE_TRIMESTER_3,
  HIGHER_EDUCATION_TRIMESTER_1,
  HIGHER_EDUCATION_TRIMESTER_2,
  HIGHER_EDUCATION_TRIMESTER_3
} from '../../helpers/enrolment'
import UnitHolder from './UnitHolder'
import { groupBy, sortBy } from 'lodash'
import classNames from 'classnames';
import { getDropDateUnitText } from '../../helpers/unitDropDateHelper'
import BlockType from '../../enums/BlockType'

class UnitTable extends Component {
  constructor(props) {
    super(props)

    this.state = {
      locations: [],
      studyPeriodWeightings: []
    }
  }

  componentDidMount() {
    Promise.all([getStudyPeriodWeightings()]).then(([studyPeriodWeightings]) => {
      this.setState({
        loading: false,
        studyPeriodWeightings: studyPeriodWeightings
      })
    })

    getReferences().then(({ locationList = [] }) => {
      this.setState({
        locations: locationList
      })
    })
  }

  getTeachingPeriodSortWeights = studyPeriodCode => {
    let studyPeriodWeighting = this.state.studyPeriodWeightings.filter(studyPeriodWeighting => studyPeriodWeighting.studyPeriodCode === studyPeriodCode)

    return studyPeriodWeighting.length > 0 ? studyPeriodWeighting[0].sortOrder : 1000
  }

  getUnitsByYear = year => {
    return sortBy(this.props.units, function(unit) {
      return new Date(unit.unitStartDate)
    })
      .filter(unit => unit.unitAvailabilityYear === parseInt(year))
      .sort((a, b) => {
        if (this.getTeachingPeriodSortWeights(a.unitAvailabilityStudyPeriodCode) < this.getTeachingPeriodSortWeights(b.unitAvailabilityStudyPeriodCode)) {
          return -1
        }

        if (this.getTeachingPeriodSortWeights(a.unitAvailabilityStudyPeriodCode) > this.getTeachingPeriodSortWeights(b.unitAvailabilityStudyPeriodCode)) {
          return 1
        }

        return 0
      })
  }

  getUnitsByCalendarType = (calendarType, year) => {
    return this.getUnitsByYear(year).filter(unit => unit.unitAvailabilityStudyPeriodCode === calendarType)
  }

  getUnitsByCalendarTypes = (calendarTypes = [], year) => {
    return this.getUnitsByYear(year).filter(unit => calendarTypes.indexOf(unit.unitAvailabilityStudyPeriodCode) > -1)
  }

  getUnsupportedCalendarTypeUnits = year => {
    const units = this.getUnitsByYear(year).filter(unit => !getSupportedCalendarTypes().some(supportedCalendarType => supportedCalendarType === unit.unitAvailabilityStudyPeriodCode))

    return groupBy(units, 'unitAvailabilityStudyPeriodCode')
  }

  getUnitBlock = unit => {
    // Flag enrolled units which share a unit code with another enrolled unit
    // as invalid
    const unitCode = unit.unitCode
    //added below filters as part of DSES-117 and DSES-84
    const unitsWithSameCode = this.props.units
      .filter(unit => unit.unitStatus !== 'FAIL')
      .filter(unit => unit.unitCd === unitCode)
      .filter(({ virtual }) => virtual !== true)

    if (unitsWithSameCode.length > 1) {
      return (
        <div className="unit-holder">
          <UnitHolder unit={unit} status="INVALID" campus={unit.unitAvailabilityLocationDescription} />
          {getDropDateUnitText(unit)}
        </div>
      )
    }

    return (
      <div className="unit-holder">
        <UnitHolder unit={unit} status={unit.unitStatus} campus={unit.unitAvailabilityLocationDescription} />
        {getDropDateUnitText(unit)}
      </div>
    )
  }

  getBlockContainer = (children, calendarType, year, isBlockMode) => (
    <div className="col-xs-6 col-md-3" key={year + calendarType}>
      <div className="block-container">
        {isBlockMode && <div className="block">{calendarType}</div>}
        {React.Children.map(children, (child, index) => 
          React.cloneElement(child, { key: `${year + calendarType}-${index}` })
        )}
      </div>
    </div>
  )

  getBlockUnits = (calendarType, year, numberOfInstances, isAdmissionBlock, childrenArray = []) => {
    const allCalanderUnits = this.getUnitsByCalendarType(calendarType, year)

    let isInvalid = false

    if (allCalanderUnits.length === 0 && isAdmissionBlock) {
      let noUnitCounter = 0
      for (noUnitCounter = 0; noUnitCounter < numberOfInstances; noUnitCounter++) {
        let children = this.getNoUnitHolder(isAdmissionBlock, calendarType, year)
        childrenArray.push(this.getBlockContainer(children, calendarType, year, true))
      }
    } else if (allCalanderUnits.length > 0) {
      let splitUnitsBasedOnNumberOfInstances = []

      if (numberOfInstances === 1) {
        splitUnitsBasedOnNumberOfInstances.push(allCalanderUnits)
        //isInvalid = allCalanderUnits.length > 1
      } else {
        let odd = []
        let even = []
        let indexCounter = 0
        for (indexCounter = 0; indexCounter < allCalanderUnits.length; indexCounter++) {
          if (indexCounter % 2) {
            odd.push(allCalanderUnits[indexCounter])
          } else {
            even.push(allCalanderUnits[indexCounter])
          }
        }

        if (even.length > 0) {
          splitUnitsBasedOnNumberOfInstances.push(even)
        }
        if (odd.length > 0) {
          splitUnitsBasedOnNumberOfInstances.push(odd)
        }

        //isInvalid = even.length > 1 || odd.length > 1
      }

      let unitsCounter = 0
      for (unitsCounter = 0; unitsCounter < splitUnitsBasedOnNumberOfInstances.length; unitsCounter++) {
        let childern = []
        let units = splitUnitsBasedOnNumberOfInstances[unitsCounter]

        let unitCounter = 0

        for (unitCounter = 0; unitCounter < units.length; unitCounter++) {
          let unit = units[unitCounter]

          if (!(unit.removed == true && unit.virtual == true)) {
            childern.push(this.getUnitHolder(unit, units.length > 1, isInvalid))
          }
        }

        if (childern.length > 0) {
          childrenArray.push(this.getBlockContainer(childern, calendarType, year, true))
        }
      }

      if (numberOfInstances > 1 && splitUnitsBasedOnNumberOfInstances.length - numberOfInstances !== 0) {
        let loopCounter = 0
        let requireCount = numberOfInstances - splitUnitsBasedOnNumberOfInstances.length

        for (loopCounter = 0; loopCounter < requireCount; loopCounter++) {
          let childern = this.getNoUnitHolder(isAdmissionBlock, calendarType, year)
          childrenArray.push(this.getBlockContainer(childern, calendarType, year, true))
        }
      }
    }
    return childrenArray
  }

  getUnitHolder = (unit, hasMultiple, isInvalid) => {
    if (isInvalid) {
      return <UnitHolder unit={unit} status="INVALID" campus={unit.unitAvailabilityLocationDescription} />
    } else {
      //return <UnitHolder unit={unit} campus={unit.unitAvailabilityLocationDescription} />
      return this.getUnitBlock(unit)
    }
  }

  getNoUnitHolder = (isAdmissionBlock, calendarType, year, isBlockMode) => {
    let childrens = []

    childrens.push(
      <div className={classNames('unit-holder')}>
        <div className="unit-container">
          <div className="unit unit--add">
            <h3>No unit</h3>
          </div>
        </div>
      </div>
    )

    return childrens
  }

  getUnsupportedUnitSections = year => {
    const calendarTypeUnits = this.getUnsupportedCalendarTypeUnits(year)

    return Object.keys(calendarTypeUnits)
      .filter(calendarType => calendarTypeUnits[calendarType])
      .map(calendarType => {
        const units = calendarTypeUnits[calendarType]

        return this.getSkeleton(calendarType, units)
      })
  }

  getSupportedUnitSection = (title, calendarTypes = [], year) => {
    if (this.getUnitsByCalendarTypes(calendarTypes, year).length === 0) {
      return null
    }

    return this.getSkeleton(title, this.getUnitsByCalendarTypes(calendarTypes, year))
  }

  getBlockUnitSection = (title, calendarTypes = [], dualInstanceCalendarTypes = [], defaultCalendarType, year) => {
    const allCalendarTypes = calendarTypes
      .concat(dualInstanceCalendarTypes)
      .concat(defaultCalendarType)
      .filter(calendarType => calendarType !== '')

    if (this.getUnitsByCalendarTypes(allCalendarTypes, year).length === 0) {
      return null
    }
    
    if (this.props.hasBlockStatus) {
      let templatedCalendarTypes = []
      let nonTemplatedCalendarTypes = []
      //dual instance or single instance template first
      if (this.props.blockMode === BlockType.EightWeekBlock) {
        templatedCalendarTypes = dualInstanceCalendarTypes
        nonTemplatedCalendarTypes = calendarTypes
      } else {
        templatedCalendarTypes = calendarTypes
        nonTemplatedCalendarTypes = dualInstanceCalendarTypes
      }
      return (
        <div>
          <h2>{title}</h2>
          <div className="semester-container">
            <div className="row">
              {templatedCalendarTypes.length > 0 &&
                templatedCalendarTypes.map((calendarType, index) =>  
                  this.getBlockUnits(
                    calendarType,
                    year,
                    this.isEightWeekBlockCalendar(calendarType) ? 2 : 1,
                    this.isEightWeekBlockCalendar(calendarType) ? this.props.blockMode === BlockType.EightWeekBlock : this.props.blockMode === BlockType.FourWeekBlock
                  )
                )}
              {nonTemplatedCalendarTypes.length > 0 &&
                nonTemplatedCalendarTypes.map(calendarType =>
                  this.getBlockUnits(
                    calendarType,
                    year,
                    this.isEightWeekBlockCalendar(calendarType) ? 2 : 1,
                    this.isEightWeekBlockCalendar(calendarType) ? this.props.blockMode === BlockType.EightWeekBlock : this.props.blockMode === BlockType.FourWeekBlock
                  )
                )}
            </div>
            {defaultCalendarType !== '' && this.getSkeletonRow(this.getUnitsByCalendarType(defaultCalendarType, year))}
          </div>
        </div>
      )
    }

    return this.getSupportedUnitSection(title, allCalendarTypes, year)
  }

  isEightWeekBlockCalendar = calendarType => {
    return calendarType.indexOf('H8W') > -1
  }

  getVuOnlineStudyPeriodUnitSection = () => {
    if (this.getUnitsByCalendarTypes(getVuOnlineStudyPeriodCalendarTypes(), this.props.year).length === 0) {
      return null
    }

    return (
      <div>
        <h2>Study periods</h2>
        <div className="semester-container">
          <div className="row">{getVuOnlineStudyPeriodCalendarTypes().map(calendarType => this.getBlockUnits(calendarType, this.props.year, 1, true))}</div>
        </div>
      </div>
    )
  }

  getSkeleton = (title, units = []) => {
    return (
      <div key={title}>
        <h2>{title}</h2>
        <div className="semester-container">{this.getSkeletonRow(units)}</div>
      </div>
    )
  }

  getSkeletonRow = (units = []) => {
    return units.length ? (
      <div className="row">
        {units.map(unit => (
          <div key={unit.unitCd} className="col-xs-6 col-md-3">
            <div className="block-container">
              <div className="block">{unit.unitAvailabilityStudyPeriodCode}</div>
              {this.getUnitBlock(unit)}
            </div>
          </div>
        ))}
      </div>
    ) : null
  }

  render() {
    return (
      <div>
        <h1 className="page__title">{this.props.year}</h1>

        {this.getVuOnlineStudyPeriodUnitSection()}
        {this.getBlockUnitSection('Summer Block (January)', getSummerBlockModelOpeningCalendarTypes(), [], '', this.props.year)}
        {this.getBlockUnitSection('Semester 1', getSemester1BlockModelCalendarTypes(), getSemester1DualInstanceBlockModelCalendarTypes(), HIGHER_EDUCATION_SEMESTER_1, this.props.year)}
        {this.getBlockUnitSection('Winter Block', getWinterBlockModelCalendarTypes(), [], HIGHER_EDUCATION_SEMESTER_4, this.props.year)}
        {this.getBlockUnitSection('Semester 2', getSemester2BlockModelCalendarTypes(), getSemester2DualInstanceBlockModelCalendarTypes(), HIGHER_EDUCATION_SEMESTER_2, this.props.year)}
        {this.getSupportedUnitSection('Summer Semester', [HIGHER_EDUCATION_SEMESTER_3], this.props.year)}
        {this.getBlockUnitSection('Summer Block (December)', getSummerBlockModelClosingCalendarTypes(), [], '', this.props.year)}
        {this.getBlockUnitSection('8 Week - Block 5', [], getDualInstanceBlockWeek5CalendarTypes(), '', this.props.year)}
        {this.getSupportedUnitSection('Trimester 1', [HIGHER_EDUCATION_MELBOURNE_TRIMESTER_1], this.props.year)}
        {this.getSupportedUnitSection('Trimester 2', [HIGHER_EDUCATION_MELBOURNE_TRIMESTER_2], this.props.year)}
        {this.getSupportedUnitSection('Trimester 3', [HIGHER_EDUCATION_MELBOURNE_TRIMESTER_3], this.props.year)}
        {this.getSupportedUnitSection('Trimester 1', [HIGHER_EDUCATION_TRIMESTER_1], this.props.year)}
        {this.getSupportedUnitSection('Trimester 2', [HIGHER_EDUCATION_TRIMESTER_2], this.props.year)}
        {this.getSupportedUnitSection('Trimester 3', [HIGHER_EDUCATION_TRIMESTER_3], this.props.year)}

        {this.getUnsupportedUnitSections(this.props.year)}
      </div>
    )
  }
}

export default UnitTable
